import { render, staticRenderFns } from "./NotFound.vue?vue&type=template&id=ab91dfd6&scoped=true"
var script = {}
import style0 from "./NotFound.vue?vue&type=style&index=0&id=ab91dfd6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab91dfd6",
  null
  
)

export default component.exports